import * as React from 'react';

import { Direction } from '~shared/utils/sort';
import { PERSONAL_LIBRARY_SORT_SESSION_KEY } from '~teacher/components/quizzes/QuizList/librarySortSessionKeys';
import { useColumnSortReducer } from '~teacher/components/quizzes';
import { LibraryPanel } from '~teacher/components/quizzes/LibraryPanel/LibaryPanel';
import { useFilteredSortedQuizListItems } from '~teacher/components/quizzes/QuizList/useFilteredSortedQuizListItems';
import { getQuizLibraryFilter } from '~teacher/components/quizzes/QuizListFilters';
import { useQuizzes } from '~teacher/hook';
import { sortQuizListItems } from '~teacher/pages/sortQuizListItems';

import { uniqueIdFactory } from '../../../../api/quiz/getQuizzes/normalize/uniqueIds';
import { QuizOrFolder } from '../../../../api/quiz/getQuizzes/types';
import { personalQuizUrl as quizUrl } from '../../../../api/urls';

interface Props {
  parentId?: number;
  setParentId: (newParentId: number) => void;
}

export function LibraryPanelByParentId({ parentId, setParentId }: Props) {
  const quizzes = useQuizzes();

  const [
    { direction: sortDirection, quizListColumn: sortProperty },
    dispatchColumnSortAction,
  ] = useColumnSortReducer({
    initialToggleDirection: Direction.Ascending,
    sessionStorageKey: PERSONAL_LIBRARY_SORT_SESSION_KEY,
  });

  const sortQuizItems = React.useCallback(
    (items: QuizOrFolder[]): QuizOrFolder[] =>
      sortQuizListItems({
        items: items,
        sortProperty: sortProperty,
        sortDirection: sortDirection,
      }),
    [sortProperty, sortDirection]
  );

  const {
    selectedQuizItem,
    isSelectedAll,
    toggleSelectAll,
    toggleItem,
    quizOrFolders: sortedQuizItems,
    selectNone,
  } = useFilteredSortedQuizListItems({
    quizListItems: quizzes.data,
    filter: getQuizLibraryFilter(uniqueIdFactory.folder.toUniqueId(parentId)),
    sort: sortQuizItems,
  });

  return (
    <LibraryPanel
      QuizUrl={quizUrl}
      setParentId={setParentId}
      sortProperty={sortProperty}
      sortDirection={sortDirection}
      isSelectedAll={isSelectedAll}
      selectedQuizItem={selectedQuizItem}
      dispatchColumnSortAction={dispatchColumnSortAction}
      selectNone={selectNone}
      toggleSelectAll={toggleSelectAll}
      toggleItem={toggleItem}
      parentId={parentId}
      quizItems={sortedQuizItems}
    />
  );
}
